import { parse } from 'date-fns';

export const parseDate = (date: string, pattern: string): Date => parse(date, pattern, new Date());
